import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, RadialLinearScale } from 'chart.js';
import { Pie, Doughnut, Bar, PolarArea } from 'react-chartjs-2';
import axios from 'axios';
import Button from '@mui/material/Button';
import { BASE_URL } from '../../urlConfig/Url';
import { getName } from '../Other/common';
import './DashboardHome.css';
import { useNavigate } from 'react-router-dom';


ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, RadialLinearScale);

const DashboardHome = () => {
  const [summaryData, setSummaryData] = useState(null);
  const [chartData, setChartData] = useState(null);
 const navigation = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const summaryResponse = await axios.post(`${BASE_URL}/api/dash/summary`, {
          PlantCode: getName().PlantCode,
        });
        setSummaryData(summaryResponse.data.response);

        const chartResponse = await axios.get(`${BASE_URL}/api/dash/pieChartData`);
        setChartData(chartResponse.data.response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const colors = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'];

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 12,
          font: { size: 10 },
        },
      },
    },
  };

  const getChartData = (dataKey = 'Total') => ({
    labels: chartData?.map(item => item.Scode) || [],
    datasets: [{
      data: chartData?.map(item => item[dataKey]) || [],
      backgroundColor: colors,
      hoverBackgroundColor: colors,
    }],
  });

  const barChartData = {
    ...getChartData(),
    datasets: [{
      ...getChartData().datasets[0],
      label: 'Asset Count',
    }],
  };

  const SummaryItem = ({ title, value, color, index }) => (
    <div className={`summary-item summary-item-${index % 6}`}>
      <h3>{title}</h3>
      <p style={{ color }}>{value}</p>
    </div>
  );

  const handleClick = () => {
    if (window.confirm('Are you sure you want to navigate to 3D Building Visualization?')) {
      window.open('/3d', '_blank');
    }
  };

  return (
    <div className="dashboard-home">
      <h1 className="dashboard-title">Dashboard Overview</h1><Button variant="contained" color='secondary' onClick={handleClick} sx={{mb: 2}}>3D Building Visualization</Button>
      
      <div className="summary-grid">
        {summaryData && Object.entries(summaryData).map(([key, value], index) => (
          <SummaryItem
            key={key}
            title={key.replace(/([A-Z])/g, ' $1').trim()}
            value={value}
            color={colors[index % colors.length]}
            index={index}
          />
        ))}
      </div>

      {chartData && (
        <div className="charts-grid">
          <div className="chart-card">
            <h2>Asset Distribution (Pie)</h2>
            <div className="chart-container">
              <Pie data={getChartData()} options={chartOptions} />
            </div>
          </div>

          <div className="chart-card">
            <h2>Asset Overview (Doughnut)</h2>
            <div className="chart-container">
              <Doughnut data={getChartData()} options={chartOptions} />
            </div>
          </div>

          <div className="chart-card">
            <h2>Asset Comparison (Bar)</h2>
            <div className="chart-container">
              <Bar data={barChartData} options={{...chartOptions, indexAxis: 'y'}} />
            </div>
          </div>

          <div className="chart-card">
            <h2>Asset Distribution (Polar Area)</h2>
            <div className="chart-container">
              <PolarArea data={getChartData()} options={chartOptions} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardHome;